"use strict";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import { History } from "react-router";
import Api from "../../api/api";
import uuid from "@lukeed/uuid";
import Auth from "../../util/auth";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
export const INVOICE_CONTEXT = "invoice";
export const DOCUMENTS_CONTEXT = "documents";
export const BILLING_TYPE = "billing";
export const PAYMENT_TYPE = "payment";
function renderOption(message) {
  return /* @__PURE__ */ React.createElement("option", { value: message }, message);
}
function savingButton() {
  return /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
}
function paymentExceptionTypeLabel() {
  return "Payment";
}
function showExceptionTypeArea() {
  return Account.auditBillingEnabled();
}
export default React.createClass({
  mixins: [History],
  getInitialState: function() {
    const isPaymentSelectedByDefault = this.props.modelObjectType === CARRIER_INVOICE_MODEL_OBJECT_TYPE;
    const isBillingSelectedByDefault = this.props.modelObjectType === LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
    return {
      autofilledExceptionMessage: this.initialExceptionMessage(),
      billingSelected: isBillingSelectedByDefault,
      paymentSelected: isPaymentSelectedByDefault
    };
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.newExceptionV3Reskin();
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "rules__new-exception", "data-component": "NewException" }, this.newException());
    }
  },
  loadNotFoundMessage: "Load not found.",
  noNeedToProcessMessage: "Does not need to be processed.",
  otherMessage: "Other",
  documentsMessages: function() {
    const messages = [this.loadNotFoundMessage];
    if (!Auth.getCurrentUser().managed_indexer) {
      messages.push(this.noNeedToProcessMessage);
    }
    messages.push(this.otherMessage);
    return messages;
  },
  documentsOptions: function() {
    return this.documentsMessages().map(renderOption);
  },
  invoiceMessages: function() {
    const messages = Api.Account.currentSettings().custom_invoice_exception_messages || [];
    const sortedMessages = _.sortBy(messages, (message) => {
      return message.toLowerCase();
    });
    sortedMessages.push(this.otherMessage);
    return [...new Set(sortedMessages)];
  },
  invoiceOptions: function() {
    return this.invoiceMessages().map(renderOption);
  },
  initialExceptionMessage: function() {
    if (this.props.context === INVOICE_CONTEXT) {
      return this.otherMessage;
    }
    return this.documentsMessages()[0];
  },
  newException: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.possibleUserInstructions(), this.descriptionDropdown(), this.possibleTextArea(), this.possibleCreateExceptionButton());
  },
  newExceptionV3Reskin: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "16px",
          background: "var(--color-grayscale-100)",
          border: "1px solid var(--color-border-default)",
          borderRadius: "8px"
        }
      },
      this.possibleExceptionTypeAreaV3Reskin(),
      this.descriptionDropdownV3Reskin(),
      this.possibleTextAreaV3Reskin(),
      /* @__PURE__ */ React.createElement("div", { style: { alignSelf: "flex-end" } }, this.possibleCreateExceptionButtonV3Reskin())
    );
  },
  descriptionOptions: function() {
    if (this.props.context === INVOICE_CONTEXT) {
      return this.invoiceOptions();
    }
    return this.documentsOptions();
  },
  descriptionDropdown: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "new-exception__description-dropdown" }, /* @__PURE__ */ React.createElement("label", null, "Exception Description"), /* @__PURE__ */ React.createElement(
      "select",
      {
        value: this.state.autofilledExceptionMessage,
        onChange: (e) => this.setState({
          autofilledExceptionMessage: e.target.value
        })
      },
      this.descriptionOptions()
    ));
  },
  descriptionDropdownV3Reskin: function() {
    return /* @__PURE__ */ React.createElement("label", { className: "v3__input-label" }, /* @__PURE__ */ React.createElement("div", { className: "v3__input-label-text" }, "Exception type"), /* @__PURE__ */ React.createElement("div", { className: "v3__input-wrapper" }, /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "v3__input v3__simple-select v3__simple-select--size-medium",
        value: this.state.autofilledExceptionMessage,
        onChange: (e) => this.setState({
          autofilledExceptionMessage: e.target.value
        })
      },
      this.descriptionOptions()
    )));
  },
  possibleUserInstructions: function() {
    if (this.props.context === DOCUMENTS_CONTEXT) {
      return /* @__PURE__ */ React.createElement("div", { className: "new-exception__user-instructions" }, "If the problem is related to a missing document or amount mismatch, create the exception on the confirm and submit screen.");
    }
  },
  possibleTextArea: function() {
    if (this.state.autofilledExceptionMessage === "Other") {
      return /* @__PURE__ */ React.createElement("div", { className: "new-exception__text-area" }, /* @__PURE__ */ React.createElement("label", null, "Description"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          value: this.state.customExceptionMessage || "",
          onChange: (e) => this.setState({
            customExceptionMessage: e.target.value
          }),
          rows: 4
        }
      ));
    }
  },
  possibleTextAreaV3Reskin: function() {
    if (this.state.autofilledExceptionMessage === "Other") {
      return /* @__PURE__ */ React.createElement("label", { className: "v3__input-label" }, /* @__PURE__ */ React.createElement("div", { className: "v3__input-label-text" }, "Description"), /* @__PURE__ */ React.createElement("div", { className: "v3__input-wrapper" }, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          className: "v3__input",
          placeholder: "Describe the exception",
          value: this.state.customExceptionMessage || "",
          onChange: (e) => this.setState({
            customExceptionMessage: e.target.value
          }),
          style: { height: "126px" }
        }
      )));
    }
  },
  cancelException: function() {
    this.setState({ customExceptionMessage: "" });
    this.props.onCancel();
  },
  createExceptionAndSend: function() {
    if (this.props.context === INVOICE_CONTEXT) {
      this.createException(true, this.buildTypes());
    } else {
      this.createException(true);
    }
  },
  createExceptionWithoutSending: function() {
    if (this.props.context === INVOICE_CONTEXT) {
      this.createException(false, this.buildTypes());
    } else {
      this.createException(false);
    }
  },
  buildTypes: function() {
    const types = [];
    if (this.state.billingSelected) {
      types.push(BILLING_TYPE);
    }
    if (this.state.paymentSelected) {
      types.push(PAYMENT_TYPE);
    }
    return types;
  },
  createException: function(sendMessage, types) {
    var hasMore = this.props.hasMore;
    var create = () => {
      this.setState({ saving: true });
      this.props.exceptionCreator(this.exceptionMessage(), this.ignored(), types).then(() => {
        this.exceptionCreationComplete(sendMessage, hasMore);
      });
    };
    if (this.ignored()) {
      if (confirm("Are you sure you would like to ignore this group?")) {
        create();
      }
    } else {
      create();
    }
  },
  exceptionCreationComplete: function(sendMessage, hasMore) {
    if (sendMessage) {
      this.props.startSendEmail();
    }
    if (!_.isUndefined(hasMore)) {
      if (!sendMessage && !hasMore) {
        ToDashboardWithFilters(this.props.location, this.history);
      } else if (!sendMessage && hasMore) {
        this.props.documentsExceptionAddedCallback();
      }
    }
  },
  ignored: function() {
    return this.state.autofilledExceptionMessage === this.noNeedToProcessMessage;
  },
  exceptionMessage: function() {
    var autofilledExceptionMessage = this.state.autofilledExceptionMessage;
    var customExceptionMessage = this.state.customExceptionMessage;
    return autofilledExceptionMessage === "Other" ? customExceptionMessage : autofilledExceptionMessage;
  },
  possibleCreateExceptionButton: function() {
    if (this.props.hasMore) {
      var completionContext = "and go to next group";
    } else {
      var completionContext = "and return to dashboard";
    }
    if (this.state.saving) {
      return /* @__PURE__ */ React.createElement("div", { className: "new-exception__possible-create-exception-button" }, savingButton());
    } else {
      if (this.props.startSendEmail) {
        return /* @__PURE__ */ React.createElement("div", { className: "new-exception__possible-create-exception-button" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "rules__add-exception-button",
            disabled: this.isSaveDisabled(),
            onClick: this.createExceptionAndSend
          },
          "Save & Send Message"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "button--secondary",
            disabled: this.isSaveDisabled(),
            onClick: this.createExceptionWithoutSending
          },
          "Save Without Sending"
        ), /* @__PURE__ */ React.createElement("span", { className: "new-exception__completion-context" }, " ", completionContext, " "), /* @__PURE__ */ React.createElement("br", { className: "show_for_non_reskin" }), /* @__PURE__ */ React.createElement("span", { className: "new-exception__completion-context-or" }, "or "), /* @__PURE__ */ React.createElement(
          "a",
          {
            className: "new-exception__cancel-link",
            onClick: this.cancelException
          },
          "cancel"
        ));
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-4 column" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "rules__add-exception-button",
            disabled: this.isSaveDisabled(),
            onClick: this.createExceptionWithoutSending
          },
          "Save Exception"
        ), /* @__PURE__ */ React.createElement("a", { onClick: this.cancelException }, "cancel")), /* @__PURE__ */ React.createElement("div", { className: "large-6 column" }, this.possibleExceptionTypeArea()));
      }
    }
  },
  possibleCreateExceptionButtonV3Reskin: function() {
    if (this.state.saving) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          disabled: true
        },
        "Saving..."
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "16px", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Text,
          onClick: this.cancelException,
          style: { padding: "0" }
        },
        "Cancel"
      ), /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          disabled: this.isSaveDisabled(),
          onClick: this.createExceptionWithoutSending
        },
        "Save"
      ));
    }
  },
  isSaveDisabled: function() {
    const noExceptionTypeSelected = this.props.context == INVOICE_CONTEXT && showExceptionTypeArea() && !this.state.paymentSelected && !this.state.billingSelected;
    return this.state.saving || noExceptionTypeSelected;
  },
  possibleExceptionTypeArea: function() {
    if (showExceptionTypeArea()) {
      const idPrefix = `exception-type-${uuid()}`;
      const billingId = `${idPrefix}-billing`;
      const paymentId = `${idPrefix}-payment`;
      return /* @__PURE__ */ React.createElement("div", { className: "rules__exception-type-area-container" }, /* @__PURE__ */ React.createElement("span", { className: "rules__exception-type-area-label bold" }, "Exception type:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          id: billingId,
          value: billingId,
          checked: this.state.billingSelected,
          onChange: this.buildToggleExceptionTypeHandler(BILLING_TYPE)
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: billingId }, this.billingExceptionTypeLabel()), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          id: paymentId,
          value: paymentId,
          checked: this.state.paymentSelected,
          onChange: this.buildToggleExceptionTypeHandler(PAYMENT_TYPE)
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: paymentId }, paymentExceptionTypeLabel()));
    }
  },
  possibleExceptionTypeAreaV3Reskin: function() {
    if (showExceptionTypeArea()) {
      const idPrefix = `exception-type-${uuid()}`;
      const billingId = `${idPrefix}-billing`;
      const paymentId = `${idPrefix}-payment`;
      return /* @__PURE__ */ React.createElement("div", { className: "v3__input-label" }, /* @__PURE__ */ React.createElement("div", { className: "v3__input-label-text" }, "Exception"), /* @__PURE__ */ React.createElement("div", { className: "v3__input-wrapper" }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "16px" } }, /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { display: "flex", gap: "8px", alignItems: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            id: billingId,
            value: billingId,
            checked: this.state.billingSelected,
            onChange: this.buildToggleExceptionTypeHandler(BILLING_TYPE),
            style: { margin: "0" }
          }
        ),
        /* @__PURE__ */ React.createElement("label", { htmlFor: billingId, style: { margin: "0" } }, this.billingExceptionTypeLabel())
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { display: "flex", gap: "8px", alignItems: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            id: paymentId,
            value: paymentId,
            checked: this.state.paymentSelected,
            onChange: this.buildToggleExceptionTypeHandler(PAYMENT_TYPE),
            style: { margin: "0" }
          }
        ),
        /* @__PURE__ */ React.createElement("label", { htmlFor: paymentId, style: { margin: "0" } }, paymentExceptionTypeLabel())
      ))));
    }
  },
  billingExceptionTypeLabel: function() {
    if (this.props.modelObjectType === CARRIER_INVOICE_MODEL_OBJECT_TYPE) {
      return "Billing (all customers)";
    } else {
      return "Billing (this customer)";
    }
  },
  buildToggleExceptionTypeHandler: function(exceptionType) {
    return () => {
      if (exceptionType === BILLING_TYPE) {
        this.setState({
          billingSelected: !this.state.billingSelected
        });
      } else {
        this.setState({
          paymentSelected: !this.state.paymentSelected
        });
      }
    };
  }
});
